<template>
	<div class="content__column content__column--small" v-if="option">
		<h1 class="content__title">Editar / Crear Opción</h1>
		<form class="form" @submit.prevent="saveOption">
			<div class="form__fieldset">
				<div class="form__container">
					<label for="name" class="form__label form__label--required">Nombre</label>
					<input type="text" class="form__input" name="name" id="name" v-model="option.name" v-validate="validation.name" />
					<span v-show="errors.has('name')" class="form__alert" v-text="errors.first('name')"></span>
				</div>

				<div class="form__container">
					<label for="title_es" class="form__label">Titulo (Español)</label>
					<input type="text" class="form__input" name="title_es" id="title_es" v-model="option.title_es" v-validate="validation.title_es" />
					<span v-show="errors.has('title_es')" class="form__alert" v-text="errors.first('title_es')"></span>
				</div>

				<div class="form__container">
					<label for="title_en" class="form__label">Titulo (Inglés)</label>
					<input type="text" class="form__input" name="title_en" id="title_en" v-model="option.title_en" v-validate="validation.title_en" />
					<span v-show="errors.has('title_en')" class="form__alert" v-text="errors.first('title_en')"></span>
				</div>

				<div class="form__container">
					<label class="form__label form__label--required" for="description_es">Descripcíon (Español)</label>
					<textarea id="description_es" v-model="option.description_es" class="form__input from__input--textarea" name="description_es" rows="4"></textarea>
					<span v-show="errors.has('description_es')" class="form__alert" v-text="errors.first('description_es')"></span>
				</div>

				<div class="form__container">
					<label class="form__label form__label--required" for="description_en">Descripcíon (Inglés)</label>
					<textarea id="description_en" v-model="option.description_en" class="form__input from__input--textarea" name="description_en" rows="4"></textarea>
					<span v-show="errors.has('description_en')" class="form__alert" v-text="errors.first('description_en')"></span>
				</div>

				<div class="form__container">
					<label for="min_mxn" class="form__label form__label--required">Monto mínimo de compra en Pesos MXN</label>
					<input type="text" class="form__input" name="min_mxn" id="min_mxn" v-model="option.min_mxn" v-validate="validation.min_mxn" />
					<span v-show="errors.has('min_mxn')" class="form__alert" v-text="errors.first('min_mxn')"></span>
				</div>

				<div class="form__container">
					<label for="min_usd" class="form__label form__label--required">Monto mínimo de compra en Dólares USD</label>
					<input type="text" class="form__input" name="min_usd" id="min_usd" v-model="option.min_usd" v-validate="validation.min_usd" />
					<span v-show="errors.has('min_usd')" class="form__alert" v-text="errors.first('min_usd')"></span>
				</div>

				<div class="form__container">
					<label for="min_weight" class="form__label">Peso mínimo de la orden (Por defecto es Cero)</label>
					<input type="text" class="form__input" name="min_weight" id="min_weight" v-model="option.min_weight" v-validate="validation.min_weight" />
					<span v-show="errors.has('min_weight')" class="form__alert" v-text="errors.first('min_weight')"></span>
				</div>

				<div class="form__container">
					<label for="max_weight" class="form__label">Peso máximo de la orden (Por defecto no existe máximo)</label>
					<input type="text" class="form__input" name="max_weight" id="max_weight" v-model="option.max_weight" v-validate="validation.max_weight" />
					<span v-show="errors.has('max_weight')" class="form__alert" v-text="errors.first('max_weight')"></span>
				</div>

				<div class="form__container">
					<label class="form__label form__label--required" for="status_id"> Estatus del cupón</label>
					<div class="form__select-container">
						<select name="status_id" id="status_id" class="form__select" v-validate="validation.status_id" v-model="option.status_id">
							<option hidden :value="null">Seleccione un estatus</option>
							<option value="1">Activa</option>
							<option value="2">Inactiva</option>
						</select>
					</div>
					<span v-show="errors.has('status_id')" class="form__alert" v-text="errors.first('status_id')"></span>
				</div>

				<div class="form__container">
					<label class="form__label form__label--required" for="country_id">País en que aplica</label>
					<div class="form__select-container">
						<select name="country_id" id="country_id" class="form__select" v-validate="validation.country_id" v-model="option.country_id">
							<option hidden :value="null">Seleccione un país</option>
							<option v-for="(country, index) in countries" :key="index" :value="country.id" v-text="country.name_es"></option>
						</select>
					</div>
					<span v-show="errors.has('country_id')" class="form__alert" v-text="errors.first('country_id')"></span>
				</div>

				<div class="form__container" v-if="states && option.country_id === mexicoId">
					<label class="form__label form__label--required" for="state_id">Estado de México en que aplica</label>
					<div class="form__select-container">
						<select name="state_id" id="state_id" class="form__select" v-validate="validation.state_id" v-model="option.state_id">
							<option :value="null">Todos los estados (excepto los ya añadidos)</option>
							<option v-for="(state, index) in states" :key="index" :value="state.id" v-text="state.name"></option>
						</select>
					</div>
					<span v-show="errors.has('state_id')" class="form__alert" v-text="errors.first('state_id')"></span>
				</div>

			</div>
			<input type="submit" class="btn btn__action btn--regular" value="Guardar" />
			<button @click.prevent="$emit('new')" class="btn btn__transparent btn--regular">
				Agregar Nueva Opción
			</button>
		</form>
	</div>
</template>

<script>
	import httpService from '@/core/api/request'
	import { defaultDateFormat } from '@/core/libs/functions'

	export default {
		props: {
			option: {
				type: Object,
				required: false,
				default: function() {
					return {
						id: null,
						name: null,
						title_es: null,
						title_en: null,
						status_id: null,
						description_es: null,
						description_en: null,
						min_usd: 0,
						min_en: 0,
						min_weight: 0,
						max_weight: 0,
						country_id: null,
						state_id: null
					}
				}
			}
		},
		mixins: [httpService],
		data: function() {
			return {
				countries: null,
				states: null,
				mexicoId: 144,
				validation: {
					name: 'required|max:45',
					status_id: 'required|min_value:1|max_value:2',
					country_id: 'numeric|min_value:1|max:11|required',
					state_id: 'numeric|min:1|max:11',
					min_mxn: 'required|decimal|min_value:0.01|max:11',
					min_usd: 'required|decimal|min_value:0.01|max:11',
					min_weight: 'decimal|max:11',
					max_weight: 'decimal|max:11',
					title_es: 'required|max:45',
					title_en: 'required|max:45'
				}
			}
		},
		created: function() {
			this.getCountryList()
			if(this.option && this.option.country_id == this.mexicoId) {
				this.getMexicoStates()
			} else if(this.option) {
				this.option.state_id = null
			}
		},
		watch: {
			'option.country_id': {
				handler: function () {
					if(this.option.country_id && this.option.country_id == this.mexicoId) {
						this.getMexicoStates()
					} else if(this.option.country_id !== this.MéxicoId){
						this.states = null
						this.option.state_id = null
					}
				},
				deep: true
			}
		},
		methods: {
			saveOption: function() {
				this.$validator.validateAll().then(result => {
					if (result) {
						let httpRequest = {
							params: '',
							module: 'free_shipping',
							element: this.option
						}
						let action
						if (this.option.id) {
							action = this.put(this.option.id, httpRequest)
						} else {
							action = this.post(httpRequest)
						}
						action
							.then(response => {
								if (!this.option.id) {
									this.option.id = response.data.current_id
								}
								this.$store.commit('elementChanged', {
									module: 'optionEdit',
									time: Math.round(new Date().getTime() / 1000)
								})
								this.$store.commit('notificate', {
									title: 'OPCIÓN GUARDADA',
									text: 'La oción ha sido guardada correctamente',
									type: 'success'
								})
							})
							.catch(() => {
								this.$store.commit('notificate', {
									title: 'OPCIÓN NO GUARDADA',
									text: 'La opción no pudo ser guardada por favor, intente más tarde',
									type: 'error'
								})
							})
					}
				})
			},
			getCountryList: function() {
				let httpRequest = {
					module: 'countries',
					params: ''
				}
				this.get(httpRequest)
					.then(countries => {
						this.countries = countries.data
					})
					.catch(() => (this.countries = null))
			},
			getMexicoStates: function () {
				let httpRequest = {
					module: 'mexico_states',
					params: ''
				}
				this.get(httpRequest)
					.then(states => {
						this.states = states.data
					}).catch(error => {
						console.log(error)
						this.states = null
					})
			}
		}
	}
</script>

<style lang="sass">
	@import "../../assets/sass/components/_forms"
</style>



// WEBPACK FOOTER //
// src/components/free_shipping/edit.vue